import { Injectable } from '@angular/core';

/** Dido core state service. */
@Injectable()
export class DidoCoreStateService {
    /** URL including segment to DIDO web (ASPNET core)*/
    readonly didoWebUrl: string;
}
